import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";

/**
 * Re-runs `revalidate` whenever the UI language changes (not on mount), so
 * validation error text already on screen updates to the new language
 * instead of staying frozen in whichever language was active when the
 * error first appeared.
 *
 * Works with any validation approach — pass whatever re-validates the
 * current form, e.g. `() => formik.validateForm()` for Formik forms, or a
 * custom re-translation of a local `validationErrors` state object.
 *
 * @param {() => void} revalidate
 */
const useRevalidateOnLocaleChange = (revalidate) => {
  const lang = useSelector((state) => state.locale.lang);
  const skipRef = useRef(true);

  useEffect(() => {
    if (skipRef.current) {
      skipRef.current = false;
      return;
    }
    revalidate();
  }, [lang]);
};

export default useRevalidateOnLocaleChange;
